import { render, staticRenderFns } from "./sidemenu-bookmark-button.vue?vue&type=template&id=2a448ac0&scoped=true&"
import script from "./sidemenu-bookmark-button.vue?vue&type=script&lang=ts&"
export * from "./sidemenu-bookmark-button.vue?vue&type=script&lang=ts&"
import style0 from "./sidemenu-bookmark-button.vue?vue&type=style&index=0&id=2a448ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a448ac0",
  null
  
)

export default component.exports